module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71281/img/content-remix-post-publish/content-remix-en.png"